/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSendTimerModel,
  ISendTimerRequest,
  IMappers,
  ISendTimerResponse,
  ISendTimerResponseError,
  TSendTimerResponse,
} from './types';

const defaultConfig: TSendTimerModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'browser-telemetry',
  pathApi: '/v1/send-timer/',
  hostType: 'api',
} as TSendTimerModel;

function createSendTimerModel(parameters: ISendTimerRequest): TSendTimerModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISendTimerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISendTimerRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSendTimer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISendTimerOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TSendTimerResponse> {
  const { response, statusCode } = await httpApi.fetch(createSendTimerModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISendTimerResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISendTimerResponseError);
    }
  }

  return { response, statusCode } as TSendTimerResponse;
}

export { defaultConfig, createSendTimerModel, fetchSendTimer };
